'use strict';
module.exports = __dirname + '/words.txt';
